import Post from "../../types/Post";
import styles from "./styles.module.scss";
import { SocialShare } from "./socialShare";
import environment from "../../config/environment";
import Link from "next/link";
import { AuthorComponent } from "../layout/Authors";
import { LastPostComponent } from "./lastPost";
import { LastPost } from "../../types/LastPost";
import { useEffect, useState } from "react";
import { CommentsList } from "./commentsList";
import { SpeechToText } from "../layout/SpeechToText";
import { DisplayDate } from "./postDate";
import { isWebView } from "../../utils/isWebView";
import { CommentForm } from "./commentForm";
import { parseContentPost } from "../../utils/parseContentPost";
import { FaqBlock } from "./FAQ";

interface ComponentTypes {
  items: Post;
  lastPost: LastPost;
  indexAdsenseId: string;
  contentAdsenseId: string;
}

interface TagsAttr {
  databaseId: number;
  name: string;
  slug: string;
  uri: string;
}

export const Article = ({
  items,
  lastPost,
  indexAdsenseId,
  contentAdsenseId,
}: ComponentTypes) => {
  const [showSpeech, setShowSpeech] = useState<boolean>(false);
  const tags: Array<TagsAttr> = items.tags.nodes.slice(0, 4);
  const link: string = items.link;

  const postContent =
    items.content &&
    parseContentPost(items.content, indexAdsenseId, contentAdsenseId);

  useEffect(() => {
    setShowSpeech(!isWebView());
  }, []);

  return (
    <div className={styles.article}>
      <h1 className={styles.title}>{items.title}</h1>
      <div className={styles.articleHeader}>
        <div style={{ marginBottom: "1.2rem" }}>
          <DisplayDate data={items} />
        </div>

        <SocialShare shareLink={link} />
      </div>

      {showSpeech && items.content && (
        <SpeechToText
          title={items.title}
          content={items.content}
          slug={items.slug}
        />
      )}

      <div>{postContent}</div>

      {items.faqBlockBlog.items && (
        <FaqBlock itemsFaq={items.faqBlockBlog.items} />
      )}

      <div className={styles.articleFooter}>
        <AuthorComponent items={items} />
        <SocialShare shareLink={link} />

        <div className={styles.tagsContainer}>
          <p>Relacionados</p>
          {tags.length > 0 &&
            tags.map((item) => {
              return (
                <Link
                  key={item.databaseId}
                  href={`${environment.basePath}/tag/${item.slug}`}
                  passHref
                  className={styles.items}
                >
                  {item.name}
                </Link>
              );
            })}
        </div>
      </div>

      {lastPost && <LastPostComponent item={lastPost} />}

      <CommentsList items={items} count={items.commentCount} />

      <CommentForm postId={items.postId} />
    </div>
  );
};
